/* eslint-disable */
import { UseQueryOptions } from 'react-query';
import { cdfiHttpClient } from '../../../helpers/http';

export const GetCDFIChartData = (
  vintage: '0' | '1',
  skip: boolean = false
): UseQueryOptions => ({
  queryKey: [`CDFI-chart-data-${vintage}`],
  queryFn: () =>
    cdfiHttpClient.get(`/api/cdfi/chart?vintage=${vintage}&dateRange=0`),
  refetchOnMount: 'always',
  refetchOnWindowFocus: 'always',
  notifyOnChangeProps: 'tracked',
  refetchOnReconnect: 'always',
  enabled: !skip,
});

export const GetCDFIStatsData = (
  vintage: '0' | '1',
  skip: boolean = false
): UseQueryOptions => ({
  queryKey: [`CDFI-stats-data-${vintage}`],
  queryFn: () =>
    cdfiHttpClient.get(`/api/cdfi/stats?vintage=${vintage}&dateRange=0`),
  refetchOnMount: 'always',
  refetchOnWindowFocus: 'always',
  notifyOnChangeProps: 'tracked',
  refetchOnReconnect: 'always',
  enabled: !skip,
});

export const GetCDFICertificationStatsData = (
  vintage: '0' | '1',
  period: '0' | '1' | '2' | '3',
  categories: string[],
  keys: string[] = []
): UseQueryOptions => ({
  queryKey: [
    `CDFI-loan-origination-stats-data-${vintage}`,
    vintage,
    period,
    categories,
    ...keys,
  ],
  queryFn: () => {
    const categoryParams = categories
      .map((cat) => `categories=${encodeURIComponent(cat)}`)
      .join('&');
    return cdfiHttpClient.get(
      `/api/cdfi-loan-origination/stats?vintage=${vintage}&period=${period}&${categoryParams}`
    );
  },
  refetchOnMount: 'always',
  refetchOnWindowFocus: false,
  notifyOnChangeProps: 'tracked',
  refetchOnReconnect: false,
});

export const GetCDFICertificationChartData = (
  vintage: '0' | '1',
  categories: string[],
  keys: string[] = []
): UseQueryOptions => ({
  queryKey: [
    `CDFI-loan-origination-chart-data-${vintage}`,
    vintage,
    categories,
    ...keys,
  ],
  queryFn: () => {
    const categoryParams = categories
      .map((cat) => `categories=${encodeURIComponent(cat)}`)
      .join('&');
    return cdfiHttpClient.get(
      `/api/cdfi-loan-origination/chart?vintage=${vintage}&${categoryParams}`
    );
  },
  refetchOnMount: 'always',
  refetchOnWindowFocus: false,
  notifyOnChangeProps: 'tracked',
  refetchOnReconnect: false,
});

export const SetEndOfFiscalYear = async (fiscalYearEnd: Date) => {
  const options = {
    hour12: false,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  } as Intl.DateTimeFormatOptions;

  const response = await cdfiHttpClient.post(
    '/api/cdfi-loan-origination/setfiscalyearend',
    {
      fiscalyearend: `${
        fiscalYearEnd.toLocaleString('en-US', options) + ' 00:00:00'
      }`,
    }
  );

  return response.data;
};
